'use client'

import type { UseAddToCartLoadingProps } from '@/hooks/use-add-to-cart-loading.types'

import { useCallback, useEffect, useState } from 'react'

import { useCartContext } from '@maestro/commerce-blocks/context/cart.context'

const ADD_TO_CART_LOADING_TIMEOUT_MS = 30_000

export const useAddToCartLoading = (props: UseAddToCartLoadingProps) => {
  const { handleAddToCart } = props
  const { hasPendingCartChanges } = useCartContext()
  const [isAdding, setIsAdding] = useState(false)

  useEffect(() => {
    if (isAdding && !hasPendingCartChanges) {
      setIsAdding(false)
    }
  }, [hasPendingCartChanges, isAdding])

  useEffect(() => {
    if (!isAdding) {
      return
    }

    const timer = setTimeout(
      () => setIsAdding(false),
      ADD_TO_CART_LOADING_TIMEOUT_MS
    )

    return () => clearTimeout(timer)
  }, [isAdding])

  const handleAddToCartClick = useCallback(() => {
    setIsAdding(true)
    return handleAddToCart()
  }, [handleAddToCart])

  return {
    handleAddToCartClick,
    isAdding,
  }
}
